import { envs } from '../env';

export const MyTrackerEvents = {
  PwaQrInstructionOpened: 'pwa_qr_instruction_opened',
  PwaCopyInstructionOpened: 'pwa_copy_instruction_opened',
  PwaOldIosInstructionOpened: 'pwa_old_ios_instruction_opened',
  PwaInstallInstructionOpened: 'pwa_install_instruction_opened',
  PwaAndroidInstallDisabled: 'pwa_android_install_disabled',
  PwaIosInstallDisabled: 'pwa_ios_install_disabled',
} as const;

export const YaMetrikaEvents = {
  PwaQrInstructionOpened: 'pwa_qr_instruction_opened',
  PwaCopyInstructionOpened: 'pwa_copy_instruction_opened',
  PwaOldIosInstructionOpened: 'pwa_old_ios_instruction_opened',
  PwaInstallInstructionOpened: 'pwa_install_instruction_opened',
  PwaAndroidInstallDisabled: 'pwa_android_install_disabled',
  PwaIosInstallDisabled: 'pwa_ios_install_disabled',
} as const;

export type MyTrackerEvents = (typeof MyTrackerEvents)[keyof typeof MyTrackerEvents];
export type YaMetrikaEvents = (typeof YaMetrikaEvents)[keyof typeof YaMetrikaEvents];

export const sendMtEvent = (event: MyTrackerEvents) => {
  try {
    window._tmr.push({ id: Number(envs.MY_TRACKER_ID), type: 'reachGoal', goal: event });
  } catch (_: any) {}
};

export const sendYaMetrikaEvent = (event: YaMetrikaEvents) => {
  try {
    window.ym(Number(envs.YA_METRIKA_ID), 'reachGoal', event);
  } catch (_: any) {}
};
